import { useState, useEffect } from 'react';
import Modal from './Modal';

type TeaTimeModalProps = {
  isLoadingMore: boolean;
};

export function TeaTimeModal({ isLoadingMore }: TeaTimeModalProps) {
  const [isOpen, setOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  // Show modal 2 seconds after loading starts (only once)
  useEffect(() => {
    if (!isLoadingMore || hasShown) return;

    const timer = setTimeout(() => {
      setOpen(true);
      setHasShown(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [isLoadingMore, hasShown]);

  // Auto-close modal when streaming completes
  useEffect(() => {
    if (!isLoadingMore && isOpen) {
      setOpen(false);
    }
  }, [isLoadingMore, isOpen]);

  return (
    <Modal open={isOpen} onClose={() => setOpen(false)}>
      <div className="p-6 text-center">
        <div className="text-5xl mb-4">☕</div>
        <p className="text-gray-700 text-base mb-2">
          This may take a few minutes to finish loading.
        </p>
        <p className="text-gray-600 text-sm mb-6">
          No need to keep this window open—your data will keep loading in the
          background.
        </p>
        <button
          data-testid="tea-time-modal-dismiss-button"
          onClick={() => setOpen(false)}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Got it
        </button>
      </div>
    </Modal>
  );
}
